import React, { useState } from 'react';
import { Button, Input } from 'barte-design-system';
import { UI_ATTR } from './anchor';
import { Comment } from './types';
import { CommentItem } from './CommentItem';

interface Props {
  comments: Comment[]; // todos da thread, ordem cronológica (raiz primeiro)
  author: string | null;
  viewportX: number;
  viewportY: number;
  onReply: (body: string, authorName?: string) => void;
  onResolve: (rootId: string, resolved: boolean) => void;
  onDelete: (id: string) => void;
  onClose: () => void;
}

export function ThreadPanel({
  comments,
  author,
  viewportX,
  viewportY,
  onReply,
  onResolve,
  onDelete,
  onClose,
}: Props) {
  const [reply, setReply] = useState('');
  const [name, setName] = useState(author || '');
  const root = comments.find((c) => c.is_root) || comments[0];
  if (!root) return null;

  const pos = clampToViewport(viewportX, viewportY);
  const effectiveAuthor = (author || name).trim();
  const canSend = reply.trim().length > 0 && effectiveAuthor.length > 0;
  const send = () => {
    if (canSend) {
      onReply(reply.trim(), effectiveAuthor);
      setReply('');
    }
  };

  return (
    <div className="bc-popover" {...{ [UI_ATTR]: '' }} style={{ left: pos.left, top: pos.top }}>
      <div className="bc-popover__head">
        <span className="bc-popover__title">
          {root.resolved ? 'Thread resolvida' : 'Comentários'}
        </span>
        <div className="bc-row">
          <button
            type="button"
            className="bc-linkbtn"
            onClick={() => onResolve(root.id, !root.resolved)}
          >
            {root.resolved ? 'Reabrir' : 'Resolver'}
          </button>
          <button type="button" className="bc-linkbtn" onClick={onClose} aria-label="Fechar">
            ✕
          </button>
        </div>
      </div>

      <div className="bc-popover__body">
        {comments.map((c) => (
          <CommentItem
            key={c.id}
            comment={c}
            canDelete={!!author && c.author_name === author}
            onDelete={onDelete}
          />
        ))}
      </div>

      <div className="bc-popover__foot">
        {!author && (
          <Input
            label="Seu nome"
            placeholder="Como você aparece no time"
            value={name}
            onChange={(e) => setName((e.target as HTMLInputElement).value)}
          />
        )}
        <Input
          type="textarea"
          placeholder="Responder…"
          value={reply}
          rows={2}
          onChange={(e) => setReply((e.target as HTMLTextAreaElement).value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) send();
          }}
        />
        <div className="bc-row">
          <span className="bc-spacer" />
          <Button variant="fill" size="sm" onClick={send} disabled={!canSend}>
            Responder
          </Button>
        </div>
      </div>
    </div>
  );
}

function clampToViewport(x: number, y: number): { left: number; top: number } {
  const W = 320;
  const H = 380;
  const left = Math.max(12, Math.min(x + 14, window.innerWidth - W - 12));
  const top = Math.max(12, Math.min(y - 40, window.innerHeight - H - 12));
  return { left, top: Math.max(12, top) };
}
